<template>
    <div>
        <v-window v-model="tab">
            <v-window-item value="JOBLIST">
                <v-row>
                    <v-col>
                        <v-data-table-virtual :headers="jobHeaders" :items="jobs" item-value="id" fixed-header>
                            <template v-slot:item.job_title="{ item }">
                                <div @click="viewJobDetails(item)"
                                    style="text-decoration: none; color: black; cursor: pointer;">
                                    {{ item.job_title }}
                                </div>
                            </template>

                            <template v-slot:item.task_type="{ item }">
                                <div @click="viewJobDetails(item)"
                                    style="text-decoration: none; color: black; cursor: pointer;">
                                    {{ item.task_type.name }}
                                </div>
                            </template>

                            <template v-slot:item.status="{ item }">
                                <div style="cursor: pointer;" @click="viewJobDetails(item)">
                                    <div v-if="item.status === JOB_STATUS.PENDING">
                                        <v-chip color="grey lighten-1" text-color="white" small>
                                            Pending
                                        </v-chip>
                                    </div>
                                    <div v-else-if="item.status === JOB_STATUS.RUNNING">
                                        <v-chip color="blue lighten-1" text-color="white" small>
                                            Running
                                        </v-chip>
                                    </div>
                                    <div v-else-if="item.status === JOB_STATUS.COMPLETED">
                                        <v-chip color="green lighten-1" text-color="white" small>
                                            Completed
                                        </v-chip>
                                    </div>
                                    <div v-else-if="item.status === JOB_STATUS.FAILED">
                                        <v-chip color="red lighten-1" text-color="white" small>
                                            Failed
                                        </v-chip>
                                    </div>
                                    <div v-else-if="item.status === JOB_STATUS.CANCELLED">
                                        <v-chip color="orange lighten-1" text-color="white" small>
                                            Cancelled
                                        </v-chip>
                                    </div>
                                </div>
                            </template>

                            <template v-slot:item.last_run_at="{ item }">
                                <div @click="viewJobDetails(item)"
                                    style="text-decoration: none; color: black; cursor: pointer;">
                                    {{ simpleDateTimeFormat(item.last_run_at) }}
                                </div>
                            </template>

                            <template v-slot:item.next_run_at="{ item }">
                                <div @click="viewJobDetails(item)"
                                    style="text-decoration: none; color: black; cursor: pointer;">
                                    {{ simpleDateTimeFormat(item.next_run_at) }}
                                </div>
                            </template>
                            <template v-slot:item.active="{ item }">
                                <div>
                                    <v-switch v-model="item._active" @click="update_JobStatus(item.status, item)" inset
                                        color="success" :key="updateSwitch" :loading="item?.loading || false"
                                        :disabled="item?.loading ? false : disableSwitch"></v-switch>
                                </div>
                            </template>

                            <template v-slot:item.actions="{ item }">
                                <div>
                                    <v-icon @click="viewJobHistory(item.id)">mdi-history</v-icon>
                                </div>
                            </template>

                        </v-data-table-virtual>
                    </v-col>
                </v-row>
            </v-window-item>
            <v-window-item value="jobHistory">
                <v-toolbar color="green-lighten-2" density="compact">
                    <v-toolbar-title class="text-h6 font-weight-medium">
                        Job Execution History
                    </v-toolbar-title>
                    <v-btn icon="mdi-close" @click="tab = 'JOBLIST'"></v-btn>
                </v-toolbar>
                <v-row>
                    <v-col>
                        <v-data-table-virtual :headers="historyHeaders" :items="executionHistory" item-value="id"
                            fixed-header>

                            <template v-slot:item.start_time="{ item }">
                                <div style="text-decoration: none; color: black; cursor: pointer;">
                                    {{ simpleDateTimeFormat(item.start_time) }}
                                </div>
                            </template>

                            <template v-slot:item.end_time="{ item }">
                                <div style="text-decoration: none; color: black; cursor: pointer;">
                                    {{ simpleDateTimeFormat(item.end_time) }}
                                </div>
                            </template>

                            <template v-slot:item.status="{ item }">
                                <div>
                                    <div v-if="item.status === EXECUTION_STATUS.TIMEOUT">
                                        <v-chip color="red lighten-1" text-color="white" small label>
                                            TimeOut
                                        </v-chip>
                                    </div>
                                    <div v-else-if="item.status === EXECUTION_STATUS.RUNNING">
                                        <v-chip color="blue lighten-1" text-color="white" small label>
                                            Running
                                        </v-chip>
                                    </div>
                                    <div v-else-if="item.status === EXECUTION_STATUS.COMPLETED">
                                        <v-chip color="green lighten-1" text-color="white" small label>
                                            Completed
                                        </v-chip>
                                    </div>
                                    <div v-else-if="item.status === EXECUTION_STATUS.FAILED">
                                        <v-chip color="red lighten-2" text-color="white" small label>
                                            Failed
                                        </v-chip>
                                    </div>
                                    <div v-else-if="item.status === EXECUTION_STATUS.CANCELLED">
                                        <v-chip color="orange lighten-1" text-color="white" small label>
                                            Cancelled
                                        </v-chip>
                                    </div>
                                </div>
                            </template>

                            <template v-slot:item.return_value="{ item }">
                                <div v-if="item.return_value?.data">
                                    <div v-if="item.return_value.data.totalContacts" style="display: flex;">
                                        <div v-for="contact in item.return_value.data.totalContacts" :key="contact">
                                            <ContactPopup dense :contact_id="contact" :tooltip="false"
                                                :showProfile="true" size="small" style="display: flex;" />
                                        </div>
                                        <v-btn icon="mdi-dots-horizontal" color="primary" size="small" variant="text"
                                            @click="showContactsList(item)"></v-btn>
                                    </div>
                                    <div v-else>
                                        {{ item.return_value?.data.message }}
                                    </div>
                                </div>
                                <div v-else>
                                    {{ item.return_value?.message }}
                                </div>
                            </template>

                        </v-data-table-virtual>
                    </v-col>
                </v-row>
            </v-window-item>
        </v-window>
        <v-dialog v-model="viewJob" max-width="700px" max-height="700px">
            <v-card rounded="s">
                <v-card-title class="d-flex justify-space-between align-center">
                    <span class="text-h6 font-weight-medium">Job Details</span>
                    <v-btn icon="mdi-close" color="red" variant="text" @click="closeJobDetails"></v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <ObjectLoop v-if="selectedJob" :InputObject="selectedJob" />
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="viewDetailsDialog" max-width="500px" scrollable>
            <v-card rounded="xl" elevation="4">
                <v-card-title class="d-flex justify-space-between align-center py-3">
                    <span class="text-h6 font-weight-bold text-primary">Contacts List</span>
                    <v-btn icon="mdi-close" variant="text" density="comfortable" color="error"
                        @click="viewDetailsDialog = false"></v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pa-4"
                    v-if="detailedJob && detailedJob.return_value && detailedJob.return_value.data">

                    <div class="mb-4">
                        <div class="text-subtitle-1 font-weight-bold mb-2 d-flex align-center">
                            <v-icon start color="primary">mdi-account-group</v-icon>
                            Total Contacts ({{ detailedJob.return_value.data.totalContacts?.length || 0 }})
                        </div>
                        <div class="d-flex flex-wrap align-center justify-start">
                            <div v-for="contact in detailedJob.return_value.data.totalContacts"
                                :key="'total-' + contact" class="ma-1">
                                <ContactPopup dense :contact_id="contact" :tooltip="true" :showProfile="true"
                                    size="small" />
                            </div>
                            <div v-if="!detailedJob.return_value.data.totalContacts?.length"
                                class="text-caption text-grey pa-2">
                                None
                            </div>
                        </div>
                    </div>

                    <v-divider class="my-3"></v-divider>

                    <div class="mb-4">
                        <div class="text-subtitle-1 font-weight-bold mb-2 text-green d-flex align-center">
                            <v-icon start color="green">mdi-message-text</v-icon>
                            SMS Sent ({{ detailedJob.return_value.data.totalSMSRemindersSent?.length || 0 }})
                        </div>
                        <div class="d-flex flex-wrap align-center justify-start">
                            <div v-for="contact in detailedJob.return_value.data.totalSMSRemindersSent"
                                :key="'sms-' + contact" class="ma-1">
                                <ContactPopup dense :contact_id="contact" :tooltip="true" :showProfile="true"
                                    size="small" />
                            </div>
                            <div v-if="!detailedJob.return_value.data.totalSMSRemindersSent?.length"
                                class="text-caption text-grey pa-2">
                                None
                            </div>
                        </div>
                    </div>

                    <v-divider class="my-3"></v-divider>

                    <div class="mb-4">
                        <div class="text-subtitle-1 font-weight-bold mb-2 text-orange d-flex align-center">
                            <v-icon start color="orange">mdi-email</v-icon>
                            Emails Sent ({{ detailedJob.return_value.data.totalEmailRemindersSent?.length || 0 }})
                        </div>
                        <div class="d-flex flex-wrap align-center justify-start">
                            <div v-for="contact in detailedJob.return_value.data.totalEmailRemindersSent"
                                :key="'email-' + contact" class="ma-1">
                                <ContactPopup dense :contact_id="contact" :tooltip="true" :showProfile="true"
                                    size="small" />
                            </div>
                            <div v-if="!detailedJob.return_value.data.totalEmailRemindersSent?.length"
                                class="text-caption text-grey pa-2">
                                None
                            </div>
                        </div>
                    </div>
                    <div class="mb-4">
                        <div class="text-subtitle-1 font-weight-bold mb-2 d-flex align-center" style="color:#06B994;" >   <v-icon start color="#06B994">mdi-account-reactivate-outline</v-icon>
                            Recall Procedures (Update/Delete) ({{ detailedJob.return_value.data.totalRecallProcedures?.length || 0 }})
                        </div>
                        <div class="d-flex flex-wrap align-center justify-start">
                            <div v-for="contact in detailedJob.return_value.data.totalRecallProcedures"
                                :key="'email-' + contact" class="ma-1">
                                <ContactPopup dense :contact_id="contact" :tooltip="true" :showProfile="true"
                                    size="small" />
                            </div>
                            <div v-if="!detailedJob.return_value.data.totalRecallProcedures?.length"
                                class="text-caption text-grey pa-2">
                                None
                            </div>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <ConfirmationAlert ref="confirmationAlertRef" />
        <ConfirmationText ref="confirmationTextRef" />
    </div>
</template>

<script>
import taskEngineService from '../../services/taskEngineService';
import dayjsMixin from "@/mixins/dayjsMixin";
import { JOB_STATUS, EXECUTION_STATUS, TASK_TYPES } from '../../taskEngine/constants';
import ObjectLoop from './ObjectLoop.vue';
import ConfirmationAlert from '../CustomComponents/ConfirmationAlert.vue';
import ConfirmationText from '../CustomComponents/ConfirmationText.vue';
import ContactPopup from "@/components/Avatar/ContactPopup";

export default {
    name: "JobsView",
    mixins: [dayjsMixin],
    components: {
        ObjectLoop,
        ConfirmationAlert,
        ConfirmationText,
        ContactPopup
    },
    props: {
        jobs_list: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            tab: 'JOBLIST',
            executionHistory: [],
            jobs: [],
            viewJob: false,
            selectedJob: null,
            jobHeaders: [
                { title: 'Job ID', key: 'id' },
                { title: 'Job Title', key: 'job_title' },
                { title: 'Task Type', key: 'task_type' },
                { title: 'Status', key: 'status' },
                { title: 'Last Run At', key: 'last_run_at' },
                { title: 'Next Run At', key: 'next_run_at' },
                { title: 'Active', key: 'active' },
                { title: '', key: 'actions' }
            ],
            historyHeaders: [
                { title: 'Job ID', key: 'job_id' },
                { title: 'Start Time', key: 'start_time' },
                { title: 'End Time', key: 'end_time' },
                { title: 'Status', key: 'status' },
                { title: 'Error Message', key: 'error_message' },
                { title: 'Return Value', key: 'return_value' }
            ],
            JOB_STATUS,
            EXECUTION_STATUS,
            updateSwitch: 0,
            disableSwitch: false,
            detailedJob: null,
            viewDetailsDialog: false
        };
    },

    methods: {
        isActive(status) {
            return status === JOB_STATUS.PENDING || status === JOB_STATUS.RUNNING;
        },
        async update_JobStatus(status, job) {
            // Logic to update job status
            if (status === JOB_STATUS.PENDING || status === JOB_STATUS.RUNNING) {
                status = JOB_STATUS.CANCELLED;
                const confirmed = await this.$refs.confirmationTextRef.open({
                    title: 'Confirm Cancellation',
                    text: `Are you sure you want to cancel this job? 
                    To confirm cancellation, please type <b>"CANCEL"</b> in the box below.`,
                    confirmationText: "CANCEL"
                });
                if (!confirmed) {
                    this.toggleSwitchLoading(job.id, false);
                    return;
                }
            } else {
                status = JOB_STATUS.PENDING;
                let check = await this.checkWithUser(job.id, job.task_type_id);
                if (!check) {
                    return;
                }
            }
            try {
                let res = await taskEngineService.updateJobStatus(job.id, { status: status });
                let index = this.jobs.findIndex(job => job.id === res.data.id);
                if (index !== -1) {
                    this.jobs[index] = res.data;
                    this.jobs[index]._active = this.isActive(res.data.status);
                }
            } catch (error) {
                console.error("Error updating job status: ", error);
            }
        },
        async viewJobHistory(job_id) {
            let res = await taskEngineService.getJobExecutionHistory(job_id);
            this.executionHistory = res.data;
            this.tab = 'jobHistory';
        },
        viewJobDetails(job) {
            this.selectedJob = job;
            this.viewJob = true;
        },
        closeJobDetails() {
            this.viewJob = false;
            this.selectedJob = null;
        },
        async checkWithUser(jobId, taskTypeId) {
            try {
                this.intervalID && clearInterval(this.intervalID);
                this.toggleSwitchLoading(jobId, true);
                if (taskTypeId === TASK_TYPES.SYSTEM.id) {
                    return true;
                }
                let res = await taskEngineService.getMissedReminderStats(jobId);
                if (res.data.missedReminders === 0 || res.data.yetToSendReminders === 0) {
                    return true;
                }
                let text = `<b>Missed Reminders :</b> ${res.data.missedReminders}
                <b>Yet to be send :</b>  ${res.data.yetToSendReminders}
                From <b>${res.data.from}</b> to <b>${res.data.to}</b>. 
                Do you want to send missed reminders?
                \n\n*if job was not running for more than 1 day then we will calculate missed reminders for last 24 hours from now.
                *And Reminders will be sent patients who have atleast 1 hour time from now.`;
                const confirmed = await this.$refs.confirmationAlertRef.open({
                    title: 'Confirm Action',
                    text: text
                });
                if (confirmed) {
                    //send missed reminders
                    let reminderRes = await taskEngineService.sendMissedReminders({ startTime: res.data.from, endTime: res.data.to }, jobId);
                    const info = await this.$refs.confirmationAlertRef.open({
                        title: reminderRes.data.message,
                        text: `Total Contacts: ${reminderRes.data.details.data.totalContacts.length} <br/> Total SMS Sent: ${reminderRes.data.details.data.totalSMSRemindersSent.length} <br/> Total Emails Sent: ${reminderRes.data.details.data.totalEmailRemindersSent.length}`,
                        alertMode: true
                    });
                    return false;// task will be activate automatically after sending missed reminders in backend
                } else {
                    const cancelled = await this.$refs.confirmationTextRef.open({
                        title: 'Confirm Cancellation',
                        text: `To confirm cancellation, please type <b>"CANCEL"</b> in the box below. \nif you CANCEL this action then missed reminders will not be sent anymore.`,
                        confirmationText: "CANCEL"
                    });
                    if (!cancelled) {
                        return false;
                    }
                }
                return true;
            } catch (error) {
                console.error("Error checking with user: ", error);
                return false;
            } finally {
                this.toggleSwitchLoading(jobId, false);
            }
        },
        toggleSwitchLoading(jobId, isLoading) {
            let index = this.jobs.findIndex(job => job.id === jobId);
            if (index !== -1) {
                this.jobs[index].loading = isLoading;
                this.jobs[index]._active = !isLoading && this.isActive(this.jobs[index].status);
            }
            if (isLoading) {
                this.disableSwitch = true;
            } else {
                this.disableSwitch = false;
            }
            this.updateSwitch += 1;
        },
        showContactsList(item) {
            this.detailedJob = item;
            this.viewDetailsDialog = true;
        }
    },
    watch: {
        jobs_list: {
            immediate: true,
            handler(newVal) {
                this.jobs = (newVal || []).map(j => ({ ...j, _active: this.isActive(j.status) }));
            },
            deep: true
        },
        jobs: {
            handler(newVal) {
                this.tab = 'JOBLIST'
            }
        }
    }
}
</script>

<style></style>
